'use strict';

import VideoModel from './VideoModel.js';
import ShowPagePlayer from './ShowPagePlayer.js';
import jQuery from 'jquery';
import animateAppend from './../../../vendor/jquery.animate-auto-height.0.0.1';
import Core from './../../Core/Core';
import VideoCollection from './VideoCollection';
import VideoItemTemplate from './views/videoItem.hbs';

/**
 * ShowPage
 *
 * JavaScript functions for the show page
 */
var ShowPage = (function($, window) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Give this module a name for state management
      privateNS.name = 'show';

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the window
      privateNS.$window = $(window);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create references to the featured spaces
      privateNS.$videoPlayerWrap = privateNS.$container.find('.video-player-wrap');

      // Create a reference to the external video switch button
      privateNS.$liveStreamControl = privateNS.$container.find('.watch-live-stream-wrapper');

      // Create the player for the show page
      window.p = privateNS.showPagePlayer = new ShowPagePlayer({
        container: privateNS.$container,
        showId: privateNS.$container.attr('data-id'),
        navigator: {
          changeState: privateNS.navigateToState
        }
      });

      // Add event handlers for Show All Airdates drawer
      new Core.blocks.Drawer({container: $('.show-all-airdates')});

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Make sure the main window is focused and not the video player iframe
      privateNS.$window.focus();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Handles the user interaction of clicking on a load more videos link
     * on a show page. This extracts the request information needed to
     * load videos from the clicked link, and registers a callback to
     * update the UI and update the clicked link with new load parameters
     * after the videos have been retrieved
     *
     * @param {Event} event The triggering click event
     */
    privateNS.onLoadMoreVideo = function(event) {

      // Cancel the click event
      event.preventDefault();

      // Find the element that the user activated
      var $target = $(event.target);

      // If this element is already loading content, cancel the new
      // request and immediately exit
      if ($target.attr('is-loading') === 'true') {
        return false;
      }

      // Place the target in to loading mode so that multiple requests
      // do not get made for the same assets
      $target.attr('is-loading', true);

      // Extract the data used to generate the load query
      var showId = privateNS.$container.attr('data-id'),
          videoType = $target.attr('data-video-type'),
          videoOffset = $target.attr('data-video-offset')|0,
          videoLimit = $target.attr('data-video-limit')|0;

      // Fetch video from the server based on the load more
      // that was clicked
      return (new VideoCollection()).fetch(showId, videoType, videoOffset, videoLimit + 1)
        .then(function outputVideoCollection(collection) {

          // Find the video row that this link was in, then find the
          // video list in that row
          var $videoContentRow = $target.parents('.video-content-row'),
              $videoItemList = $videoContentRow.find('.video-content-list');

          // Slice the collection to the maximum number of videos that should
          // be output on the page
          var trimmedCollection = collection.slice(
            0,
            Math.min(collection.length(), videoLimit)
          );

          // Compute the list of potentially currently playing post names
          var pathWithoutTrailingSlash = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));

          // Create a list of post names of the video that is potentially playing
          var playingPosts = [
            pathWithoutTrailingSlash.substring(pathWithoutTrailingSlash.lastIndexOf('/') + 1)
          ];

          // Map the collection of VideoModels to a collection of rendered
          // VideoModels. We can then join this in to the final output
          var newVideoItems = trimmedCollection.map(function renderVideoItem(video) {

            // Extract the video content from the model
            var content = video.getContent();

            // Transform the content to include the custom elements needed for
            // rendering the template

            // Generate the appropriate sizing information for the responsive
            // Cove thumbnail
            content.responsive_image = {
              url: content.mezzanine,
              image_sizes: [400, 300, 200, 100].map(
                function mapWidthToDimensions(width) {

                  // Return the 16:9 image dimensions
                  return {
                    width: width,
                    height: Math.floor(width * 0.5625)
                  };
                }
              ),
              sizes: [
                { breakpoint: '1201px', width: '400px' },
                { breakpoint: '769px', width: '33vw' },
                { breakpoint: '641px', width: '50vw' },
                { breakpoint: '0px', width: '100vw' }
              ],
              alt: content.title
            };

            // Determine if this item is available for playback for the current user
            content.is_playable = content.minimum_access_level <= Core.user.getAccessLevel();

            // Determine if this video item is currently in the featured player space
            content.is_playing = playingPosts.indexOf(content.slug) !== -1;

            // Flag the videos that are full episodes
            content.is_full_episode = content.display_type === 'Episode';

            // Generate the markup for the video item and return it
            return VideoItemTemplate({
              show: {
                post_name: privateNS.$container.attr('data-post-name')
              },
              content: content,
              user: {
                uid: Core.user.getUid(),
                access_level: Core.user.getAccessLevel(),
                is_signed_in: Core.user.isSignedIn(),
                is_expired: Core.user.isExpired()
              }
            });
          });

          // Unhide any video items that were hidden for two column displays
          $videoItemList.find('.video-item').removeClass('hide-for-small-up');

          // Flag this as a loaded row so future hiding is not performed
          $videoItemList.loadedMore = true;

          // If this a non-mobile device then perform an animated height scaling
          // append on the video list
          if ($.browser.mobile !== true) {

            // Listen for the end of the animated append of the new video elements
            // to update the transition duration on the list so that it is relative
            // to the number of elements that will be added
            $videoItemList.on(
              'endautoheightanimate',
              function updateTransitionDuration() {

                // Extract the transition duration css property from the list,
                // double it, and then save it back to the element
                $videoItemList.css({
                  transitionDuration: (parseFloat(
                    $videoItemList.
                      css('transition-duration').
                      replace(/[^\d\.]/, ''),
                    10
                  ) * 2) + 's'
                });

                // Stop listening for the appending animation event
                $videoItemList.off(
                  'endautoheightanimate',
                  updateTransitionDuration
                );
              }
            );

            // Append the created video items to the video list
            $videoItemList.animateAppend(newVideoItems.toArray().join(''));
          } else {

            // Otherwise for mobile devices to a traditional append
            $videoItemList.append(newVideoItems.toArray().join(''));
          }

          // Check to see if the number of results retrieved was less then the limit requested
          if (collection.length() < videoLimit + 1) {

            // Add the end class to the final video element so that it aligns
            // properly to the left in the case of videos that are not a multiple
            // of the display column count
            $videoItemList.children().last().addClass('end');

            // If it was then remove the loading element, it is no longer needed
            $target.parents('.call-to-action-row').remove();
          } else {

            // If there is still more content to retrieve, update the offsets and
            // limits for this block
            $target.attr({
              'data-video-offset': videoOffset + videoLimit,
              'data-video-limit': videoLimit * 2
            });
          }

          // Now that all video loading has been completed, turn off the loading
          // property so that the element becomes interactable again
          $target.attr('is-loading', false);

          // Blur the load more target to remove focus styling
          $target.blur();

          // Create an async execution that will remove the faded class so that
          // the individual video elements will fade in
          Core.utils.requestAnimationFrame(function() {

            // Remove the class that is keeping them faded out
            $('.video-item-watchable').removeClass('faded');
          });
        });
    };

    /**
     * Handles click interactions on a watchable piece of content
     *
     * @param {Event} event The triggering click event
     */
    privateNS.onClickWatchable = function(event) {

      // Cancel the click event
      event.preventDefault();

      // Gather the requisite information about the video for displaying the
      // video in the featured hero space
      var $target = $(event.target),
          $videoWatchable = $target.hasClass('video-item-watchable') ? $target : $target.parents('.video-item-watchable');

      // Scroll up to the player so that it is in view
      Core.utils.goToElement(privateNS.$videoPlayerWrap.offset().top - Core.header.getHeight() - Core.header.getSubHeaderHeight());

      privateNS.navigateToState($videoWatchable.attr('data-id')).then(function() {

        // Blur the clicked watchable to clear focus styling
        $videoWatchable.blur();
      });
    };

    /**
     * Switches the page in to live stream mode
     *
     * @param {Event} event The triggering event
     */
    privateNS.switchToLivestream = function switchToLivestream(event) {

      // Prevent the default screen jumping
      event.preventDefault();

      // Make sure that the live stream is not already active before switching
      if (!privateNS.$liveStreamControl.is('.active')) {

        // Set the page to the default history state when a livestream is
        // triggered
        privateNS.navigateToState(null).then(function() {

          // Finally scroll up to the player so that it is in view
          Core.utils.goToElement(privateNS.$videoPlayerWrap.offset().top - Core.header.getHeight());
        });
      }
    };

    /**
     * Navigate the page to a given state and update the history stack
     *
     * @param {null|VideoModel} state The state to navigate the page to. Accepts
     *                                null in the case of loading livestream
     *                                state
     * @returns {Promise}
     */
    privateNS.navigateToState = function navigateToState(state) {
      return privateNS.handleStateChange(state).
        then(function(model) {

          window.history.pushState(
            {
              module: privateNS.name,
              model: state === null ? state : model.toJSON()
            },
            state === null ? '' : model.getContent().title,
            privateNS.computePagePath(state === null ? state : model.getContent().slug)
          );

          return state === null ? state : model;
        });
    };

    /**
     * Attempt to load in the live stream player to the show page player space.
     * Returns the load promise from the player.
     *
     * @returns {Promise} The promise from the player
     */
    privateNS.loadLiveStreaming = function loadLiveStreaming() {

      // Start loading the streaming player form the server and return the
      // promise returned by the player
      return privateNS.showPagePlayer.loadShow();
    };

    /**
     * Attempts to load in a Cove video to the show page player space. Returns
     * the load promise from the player resolves to the loaded video
     *
     * @param {int|VideoModel} video Either a video postname or a video model
     *                                  to load into the player
     * @returns {Promise} The chained promise from the player
     */
    privateNS.loadVideo = function loadVideo(video) {

      // Load the video into the player by either its postname or a VideoModel
      // and return the promise from the player
      return privateNS.showPagePlayer.loadVideo(video);
    };

    /**
     * Accepts a show page state object and returns a promise that will either
     * resolve with the post name of the loaded content after updating the
     * featured area, or reject if the area failed to update
     *
     * @param {int|VideoModel} state The state that should be used to
     *                                  generate the video player content
     * @returns {Promise} A promise that will resolve if the player is
     *                    updated, and will be rejected otherwise. Resolves with
     *                    the post name of the loaded content
     */
    privateNS.loadFromState = function loadFromState(state) {

      // If this state is asking for an empty state, then check first to see if
      // the live stream should be loaded
      if (state === null && privateNS.$container.attr('data-streaming') === 'true') {
        return privateNS.loadLiveStreaming();
      }

      // If the page is not in livestream mode then check to see if a default
      // value for the video to load is needed (state is null)
      if (state === null) {

        // If there is no state to load, then fetch the default video that
        // was loaded for the page
        state = privateNS.$container.attr('data-hero-id');
      }

      return privateNS.loadVideo(state);
    };

    /**
     * When a show page initially loads, one of two behaviors needs to occur.
     *
     * If the page is loaded with a legacy url that contains a url fragment,
     * then the user should be redirected to the appropriate full url of the
     * content describe by the page and the fragment.
     *
     * If the page does not contain a legacy url fragment, then the page needs
     * to update the browsers history state with an object that describes the
     * current state of the page. For simplicity a call is made to the video
     * endpoint to fetch the episode data to store in the history stack. In the
     * future this could potentially be scrapped from the page instead to reduce
     * the require network requests.
     */
    privateNS.handleInitialState = function handleInitialState() {

      // Define a holder for the promise that will generate a model for the
      // initial page state
      var initialStatePromise = null;

      // Keep track of the whether or not this page is loading a legacy url
      var isLegacy = false;

      // TODO: This can potentially be done without a network request

      // Determine the episode to load, based on the hero post name
      var episodeId = privateNS.$container.attr('data-hero-id');

      // If there is a postname then fetch the video from the server
      if (typeof episodeId !== 'undefined') {
        // initialStatePromise = (new VideoModel()).fetch(
        //   episodeId
        // );
        initialStatePromise = (new VideoModel()).fetch(
          episodeId
        );
      } else {

        // Otherwise there is no content to define the state, so the state is
        // defined to be null
        initialStatePromise = $.Deferred().resolve(null);
      }

      // Finally adjust the browser state so that the history is correct
      initialStatePromise.
        then(function(model) {

          // If the model is null then use the current state
          var state = model ? model.toJSON() : null,
              title = model ? model.getContent().title : document.title;

          // If the state is null then it is safe to resize the player. There is
          // either a livestream or nothing in the featured space
          if (state === null) {
            privateNS.showPagePlayer.resizeFeaturedSpace();
          }

          // Computing the path is slightly more complicated as we can not
          // replace the top level paths

          // By default use the current page path
          var path = window.location.pathname;

          // Start by extracting the path from the model
          var modelPath = model ? privateNS.computePagePath(model.getContent().slug) : window.location.pathname;

          // If the path generated by the model is the same as the path in the
          // page or we are dealing with a legacy url then it is fine to use
          // the model path
          if (modelPath === window.location.path || isLegacy) {
            path = modelPath;
          }

          // If the browser supports it then replace the state in place to
          // maintain the proper history stack
          if ('history' in window && 'replaceState' in window.history) {

            window.history.replaceState(
              {
                module: privateNS.name,
                model: state
              },
              title,
              path
            );
          }
        });
    };

    /**
     * Accepts a show page state object and attempts to update the video player
     * with it. If successful the "Now Playing" tags on the page will be updated
     * and an event of the change will be tracked back to Google Analytics.
     * Returns a promise that will resolve with the post name of the video in
     * the player if everything succeeds, or rejects with an error object
     *
     * @param {int|VideoModel|null} state The state that should be used to
     *                                  generate the video player content
     * @returns {Promise} A promise that will resolve if the player is
     *                    updated, and will be rejected otherwise. Resolves with
     *                    the post name of the loaded content
     */
    privateNS.handleStateChange = function handleStateChange(state) {

      // Return a promise that attempts load the page with the passed in state
      return privateNS.loadFromState(state).
        then(function updateVideoItemsBasedOnPlayer(model) {

          // If loading is successful, run the cleanup actions of finishing UI
          // updates outside of the player and url tracking

          // Find the previous playing video item on the page and remove the
          // play indication class
          privateNS.$container.find('.video-item-watchable.is-playing').removeClass('is-playing');

          // If postName is defined then try to update the UI with it
          if (typeof model !== 'undefined' && model !== null) {

            // Search through the page for a watchable element that matches the
            // video that was pushed to the featured player.
            var $currentEpisode = privateNS.$container.find('[data-slug="' + model.getContent().slug + '"]');

            // If one is found, add the class to mark that it is the playing video
            $currentEpisode.addClass('is-playing');

            // Request that the Core update the page title
            Core.updateTitle(model.getContent().title);
          }

          // Pass the model along for anyone listening
          return model;
        }).
        then(function toggleLiveStreamControl(model) {

          // Toggle the live stream control based on if a video model exists
          privateNS.$liveStreamControl.toggleClass('active', model === null);

          // Pass along the status
          return model;
        }).
        then(function trackShowPageView(model) {

          // Extract the post name to get the path for
          var postName = model ? model.getContent().slug : model;

          // Request that the Core package update the tracking url for the page
          Core.updateTrackingPath('/show' + privateNS.computePagePath(postName));

          // Track the page change back to Google Analytics
          Core.trackPageView();

          // Pass the model along for anyone listening
          return model;
        });
    };

    /**
     * Handle pops off of the history stack
     *
     * @param {jQuery.event} $event
     * @returns {Promise}
     */
    privateNS.onPopState = function onPopState($event) {

      // Prevent the default screen jumping
      $event.preventDefault();

      // Extract the page state object
      var state = $event.originalEvent.state;

      // Only handle states that are relevant to the show page
      if (state && typeof state.module !== 'undefined' && state.module === privateNS.name) {

        return privateNS.handleStateChange(
          state.model === null ? state.model : new VideoModel($event.originalEvent.state.model)
        );
      }
    };

    /**
     * Gets the full url path for a episode postname based on the show page it
     * is on
     *
     * @param {string} episodePostName The post name of the episode to generate
     *                                 a page path for
     * @returns {string}
     */
    privateNS.computePagePath = function computePagePath(episodePostName) {
      return '/' + privateNS.$container.attr('data-post-name') + '/' + (episodePostName ? 'video/' + episodePostName + '/' : '');
    };

    /**
     * Handles resize transitions in to and out of the large (two-column)
     * breakpoint. Entering the two column breakpoint hides any odd
     * remaining elements in lists so that they can evenly end. Exiting
     * the two-column breakpoint un-hides said elements.
     *
     * @param event Event The triggering event
     */
    privateNS.checkBreakpoints = function checkBreakpoints(event) {

      // Check the width of the video row
      var containerWidth = privateNS.$container.outerWidth();

      // If the width falls within the two column breakpoint
      // hide any odd remaining children
      if (640 < containerWidth && containerWidth <= 768) {

        // Only operate if the view is not in two column mode
        if (privateNS.$container.isTwoColumn !== true) {

          // Get each of the video content lanes and update them
          privateNS.$container.find('.related-items').each(function (index, videoContentList) {

            // Get the video content list element from the page, and its list
            // of child elements
            var $videoContentList = $(videoContentList),
                $videoElements = $videoContentList.children();

            // Only handle this video list if new content has not yet been
            // loaded, and the row is not fully loaded, and there more than
            // two videos in the row
            if (!$videoContentList.loadedMore &&
                !$videoContentList.hasClass('loaded') &&
                $videoElements.length > 2) {

              // If there are an odd number of children, hide the last one
              if ($videoElements.length % 2 === 1) {
                $videoElements.eq($videoElements.length - 1).addClass('hide-for-small-up');
              }
            }
          });

          // Flag the container as being in a two column layout
          privateNS.$container.isTwoColumn = true;
        }
      } else {

        // Only operate if the view is still in two column mode
        if (privateNS.$container.isTwoColumn === true) {

          // If the width falls outside of the two column breakpoint,
          // (it can be either below or above), show all video items
          privateNS.$container.find('.video-item, .related-item').removeClass('hide-for-small-up');

          // Update the two column flag to represent being outside of two columns
          privateNS.$container.isTwoColumn = false;
        }
      }
    };

    /**
     * Attach the event handlers for the show / episode page
     */
    privateNS.attachHandlers = function attachHandlers() {

      // Attach the load more videos handlers
      privateNS.$container.find('.video-content-row').on(
        'click',
        '.loadmore-videos',
        privateNS.onLoadMoreVideo
      );

      // If the users browser does not support push/pop/replace state, then
      // default them to the non-ajax experience
      if ('history' in window && 'pushState' in window.history) {

        // Attach the live stream control handler
        privateNS.$liveStreamControl.on(
          'click',
          privateNS.switchToLivestream
        );

        // Attach the watch video handler
        privateNS.$container.find('.video-content-row').on(
          'click',
          '.video-item-watchable',
          privateNS.onClickWatchable
        );

        // Bind a noop to the touch start event on watchables to
        // make sure the :active state is shown on mobile
        privateNS.$container.find('.video-content-row').on(
          'touchstart',
          '.video-item-watchable',
          function noop() {
          }
        );

        // Bind a listener on the window to listen for changes in the history so
        // that the featured area is appropriately updated
        privateNS.$window.on(
          'popstate',
          privateNS.onPopState
        );

        // When the base page loads, handle the current url and adjust the users
        // state appropriately
        $(window.document).on(
          'DOMContentLoaded',
          privateNS.handleInitialState
        );

        // Bind a listener to the schedule subnav item
        $('body').on(
          'click',
          '.sub-navigation-link',
          function(e) {
            if ($(this).html().trim() === 'Schedule') {
              e.preventDefault();
              Core.utils.goToElement(privateNS.$container.find('.show-airdates').offset().top - Core.header.getHeight() - Core.header.getSubHeaderHeight() - document.documentElement.clientWidth * 0.03);
            }
          }
        );
      }

      // When the window loads or resizes, monitor for breakpoint changes and
      // update the display of the watch videos swim lanes
      privateNS.$window.on(
        'load resize',
        Core.utils.debounce(
          privateNS.checkBreakpoints,
          16
        )
      );

      $('.view-full-schedule').click(function(e) {
        $('.extra-time').show();

        e.preventDefault();
      });

      $('.about-this-show').click(function(e) {

        // Look for the show description in the page
        var $descriptionContainer = $('.show-description');

        if ($descriptionContainer && $descriptionContainer.length > 0) {
          Core.utils.dialog($descriptionContainer[0].outerHTML, 500);
        }

        e.preventDefault();
      });
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery, window);

export default ShowPage